import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {ConsultationModel} from '../../../api/model/consultation.model';
import {ConsultationConverter} from '../../../api/model/converter/consultation.converter';


@Injectable({providedIn: 'root'})
export class ConsultationDataService extends AbstractDataServiceV2<ConsultationModel, ConsultationConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: ConsultationConverter) {
        super('Consultation', http, httpUrlGenerator, logger, config, converter);
    }
}
